import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { screens } from "../config/routes";

interface PublicRouteProps {
  children: React.ReactNode;
}

/**
 * PublicRoute component that handles public-only routes.
 * Redirects to home if user is already authenticated.
 *
 * @param {PublicRouteProps} props - The component props
 * @returns {JSX.Element} The public route component
 */
const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { currentUser } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  if (currentUser) {
    // If there's a state with a 'from' path, use that, otherwise go to dashboard
    const from = location.state?.from?.pathname || screens.dashboard;
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;
